"use client";
import { FC } from "react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { SectionTitle, P } from "../home.styles";
import * as Styled from "./mainContainer.styles";
import { ArrowForwardIcon } from "@/svg/ArrowForwardIcon";

interface Props {
  selecteditem: number;
}

export const MainHome: FC<Props> = ({ selecteditem }) => {
  const { t } = useTranslation("global");

  return (
    <main>
      <Styled.DivContainer id="vision" className="animate__animated animate__fadeIn">
        <Styled.VideoContainer>
          <video className="custom-video" muted loop typeof="video/mp4" preload="auto" webkit-playsinline="true" playsInline autoPlay>
            <source src="/energy.mp4" type="video/mp4" />
          </video>
        </Styled.VideoContainer>
        <Styled.TextInnerContainer className="animate__animated animate__fadeIn">
          <Styled.DivText>
            <SectionTitle className="display-large" color={"var(--background-light)"}>
              {t("mainHome.title")}
            </SectionTitle>
            <P
              className="headline-medium"
              style={{ color: "var(--on-surface-dark)" }}
              color={selecteditem === 0 || selecteditem === 1 ? "var(--on-surface-dark) !important" : "var(--on-surface-light)  !important"}
            >
              {t("mainHome.description")}
            </P>
          </Styled.DivText>
          <Styled.BtnsContainer className="animate__animated animate__fadeIn animate__delay-0.5s">
            <Link href="/freetrial">
              <Styled.StyledButton
                disableElevation={true}
                size="medium"
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                color={selecteditem === 0 || selecteditem === 1 ? "secondary" : "primary"}
              >
                <span>{t("mainHome.freeTrial")}</span>
              </Styled.StyledButton>
            </Link>
            {/* <Link href="/freetrial" passHref>
              <Styled.LinkBtn
                size="large"
                variant="text"
                color={
                  selecteditem === 0 || selecteditem === 1
                    ? "secondary"
                    : "primary"
                }
              >
                {t("mainHome.seeMore")}
              </Styled.LinkBtn>
            </Link> */}
          </Styled.BtnsContainer>
        </Styled.TextInnerContainer>
      </Styled.DivContainer>
    </main>
  );
};
// };
